module.exports = __webpack_public_path__ + "img/chromecast_confetti.cb986c10.png";